define('score_bootstrap/Components/PageLike',[
    "jquery",
    "knockout",
    "score_bootstrap/Models/Liking/PageLikingModel",
    "eventManager"
], function (
    $,
    ko,
    PageLikingModel,
    eventManager
) {
    "use strict";

    function PageLike(scope, renderingParameters, isLiked, likeNumber, dateLiked, userName, pageId, siteName, pageVersion, uniqueId, language, likePageApiUrl) {
        var self = this;
        var instance = {};
        instance.pageLikeMessagesTransmitting = renderingParameters.PageLikeMessagesTransmitting.slice();
        instance.unlikeMessagesTransmitting = renderingParameters.UnlikeMessagesTransmitting.slice();
        instance.showMessagesTransmitting = renderingParameters.ShowMessagesTransmitting.slice();
        instance.hideMessagesTransmitting = renderingParameters.HideMessagesTransmitting.slice();
        instance.clickMessagesTransmitting = renderingParameters.ClickMessagesTransmitting.slice();

        this.likeNumber = ko.observable(likeNumber);
        this.isLiked = ko.observable(isLiked);
        this.show = ko.observable(true);

        initializePageLikingModel();

        var pageLikingModel;
        function initializePageLikingModel() {
            pageLikingModel = new PageLikingModel();
            if (userName !== undefined) pageLikingModel.userName = userName;
            if (pageId !== undefined) pageLikingModel.pageId = pageId;
            if (dateLiked !== undefined) pageLikingModel.dateLiked = dateLiked;
            if (siteName !== undefined) pageLikingModel.siteName = siteName;
            if (pageVersion !== undefined) pageLikingModel.pageVersion = pageVersion;
            if (uniqueId !== undefined) pageLikingModel.uniqueId = uniqueId;
            if (language !== undefined) pageLikingModel.language = language;
            if (isLiked !== undefined) pageLikingModel.isLiked = isLiked;
        }

        Object.defineProperties(this, {
            pageLikingModel: { value: pageLikingModel },
            likePageApiUrl: { value: likePageApiUrl },
            pageLikeMessagesTransmitting: {
                enumerable: true,
                get: function () {
                    return instance.pageLikeMessagesTransmitting.slice();
                }
            },
            unlikeMessagesTransmitting: {
                enumerable: true,
                get: function () {
                    return instance.unlikeMessagesTransmitting.slice();
                }
            },
            showMessagesTransmitting: {
                enumerable: true,
                get: function () {
                    return instance.showMessagesTransmitting.slice();
                }
            },
            hideMessagesTransmitting: {
                enumerable: true,
                get: function () {
                    return instance.hideMessagesTransmitting.slice();
                }
            },
            clickMessagesTransmitting: {
                enumerable: true,
                get: function () {
                    return instance.clickMessagesTransmitting.slice();
                }
            }
        });

        this.clickOnLike = function () {
            if (!self.pageLikingModel.isLiked) {
                self.pageLikeAction();
            } else {
                self.pageUnlikeAction();
            }
        }

        this.pageLikeAction = function () {
            if (!self.pageLikingModel.isLiked && !self.pageLikingModel.isInProgress) {
                self.pageLikingModel.isLiked = true;
                self.pageLikingModel.isInProgress = true;
                self.likePageRequest().then(function (data) {
                    self.likeNumber(data.LikesCount);
                    self.isLiked(data.IsLiked);
                    self.pageLikingModel.isInProgress = false;
                });

                self.transmitPageLikeMessage();
                self.transmitShowMessage();
                self.transmitClickMessage();
            }
        }

        this.pageUnlikeAction = function () {
            if (self.pageLikingModel.isLiked && !self.pageLikingModel.isInProgress) {
                self.pageLikingModel.isLiked = false;
                self.pageLikingModel.isInProgress = true;
                self.likePageRequest().then(function (data) {
                    self.likeNumber(data.LikesCount);
                    self.isLiked(data.IsLiked);
                    self.pageLikingModel.isInProgress = false;
                });

                self.transmitResetPageLikeMessage();
                self.transmitHideMessage();
                self.transmitClickMessage();
            }
        }

        this.showLike = function () {
            self.show(true);
        }

        this.hideLike = function () {
            self.show(false);
        }

        if (renderingParameters.PageLikeActionMessage.length) {
            renderingParameters.PageLikeActionMessage.forEach(function (messageName) {
                eventManager.subscribe(messageName, self.pageLikeAction, self);
            });
        }

        if (renderingParameters.PageUnlikeActionMessage.length) {
            renderingParameters.PageUnlikeActionMessage.forEach(function (messageName) {
                eventManager.subscribe(messageName, self.pageUnlikeAction, self);
            });
        }

        if (renderingParameters.ShowActionMessages.length) {
            renderingParameters.ShowActionMessages.forEach(function (messageName) {
                eventManager.subscribe(messageName, self.showLike, self);
            });
        }

        if (renderingParameters.HideActionMessages.length) {
            renderingParameters.HideActionMessages.forEach(function (messageName) {
                eventManager.subscribe(messageName, self.hideLike, self);
            });
        }

        if (this.pageLikeMessagesTransmitting.length) {
            this.pageLikeMessagesTransmitting.forEach(function (ev) {
                eventManager.trigger(ev, self);
            });
        }

        if (this.unlikeMessagesTransmitting.length) {
            this.unlikeMessagesTransmitting.forEach(function(ev) {
                eventManager.trigger(ev, self);
            });
        }

        ko.applyBindings(this, scope);
    }

    PageLike.prototype.transmitPageLikeMessage = function () {
        var messages = this.pageLikeMessagesTransmitting, self = this;
        if (messages.length) {
            messages.forEach(function (ev) {
                eventManager.trigger(ev, self);
            });
        }
    }

    PageLike.prototype.transmitResetPageLikeMessage = function () {
        var messages = this.unlikeMessagesTransmitting, self = this;
        if (messages.length) {
            messages.forEach(function (ev) {
                eventManager.trigger(ev, self);
            });
        }
    }

    PageLike.prototype.transmitShowMessage = function () {
        var messages = this.showMessagesTransmitting, self = this;
        if (messages.length) {
            messages.forEach(function (ev) {
                eventManager.trigger(ev, self);
            });
        }
    }

    PageLike.prototype.transmitHideMessage = function () {
        var messages = this.hideMessagesTransmitting, self = this;
        if (messages.length) {
            messages.forEach(function (ev) {
                eventManager.trigger(ev, self);
            });
        }
    }

    PageLike.prototype.transmitClickMessage = function () {
        var messages = this.clickMessagesTransmitting, self = this;
        if (messages.length) {
            messages.forEach(function (ev) {
                eventManager.trigger(ev, self);
            });
        }
    }
    
    PageLike.prototype.likePageRequest = function likePageRequest() {
        var jqXHR = $.ajax({
            url: this.likePageApiUrl,
            data: JSON.stringify(this.pageLikingModel),
            type: "POST",
            contentType: "application/json; charset=utf-8",
            dataType: "json"
        });

        return jqXHR;
    }

    PageLike.init = function init(args) {
        return args.IsExperienceEditorEditing === true ? null :
            new PageLike(args.scope, args.RenderingParameters, args.IsLiked, args.LikeNumber, args.DateLiked, args.UserName, args.PageId, args.SiteName, args.PageVersion, args.UniqueId, args.Language, args.LikePageApiUrl);
    };

    return PageLike;
});
